import { useState, useId, type ReactNode } from 'react';
import { cn } from '../lib/cn';

type Side = 'top' | 'bottom' | 'left' | 'right';

const SIDE: Record<Side, string> = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  left: 'right-full top-1/2 -translate-y-1/2 mr-2',
  right: 'left-full top-1/2 -translate-y-1/2 ml-2',
};

/** Тултип по hover + focus (мелочи → в тултип, §5a/§22). */
export function Tooltip({
  children,
  content,
  side = 'top',
  className,
}: {
  children: ReactNode;
  content: ReactNode;
  side?: Side;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span
      className={cn('relative inline-flex', className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      <span aria-describedby={open ? id : undefined} tabIndex={0} className="inline-flex outline-none">
        {children}
      </span>
      {open && (
        <span
          role="tooltip"
          id={id}
          className={cn(
            'pointer-events-none absolute z-50 whitespace-nowrap rounded-ops-sm bg-ops-navy-900 px-2.5 py-1.5',
            'text-ops-caption font-medium text-white shadow-ops-pop',
            SIDE[side],
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
}
